import { createApi } from '@reduxjs/toolkit/query/react';

import axiosBaseQuery from './axios';

// initialize an empty api service that we'll inject endpoints into later as needed
export const rootApi = createApi({
  tagTypes: [
    'Applications',
    'JobApplications',
    'JobCandidates',
    'ApplicationRequests',
    'AuthContext',
    'Documents',
    'ConnectionRequests',
    'Notifications',
    'Connections',
    'Comments',
    'Job',
    'DepartmentUsers',
    'Skills',
    'Cards',
    'Subscription',
    'Invoices',
    'JobLinkRequest',
    'LinkedAgencies',
    'JobInvites',
    'JobDocuments',
    'Department',
    'User',
    'Profile',
    'CandidateProfile',
    'Clients',
    'Recruiters',
    'Account',
    'Accounts',
    'AccountSettings',
    'ColumnPreferences',
    'CandidateSummaryFields',
    'Checklist',
    'Stakeholders',
    'OrgInvites',
    'CompanyProfile',
    'Domains',
    'OrgContacts',
    'OrgCandidates',
    'LinkedCandidateContacts',
    'IncomingCandidateInvites',
    'OutgoingCandidateInvites',
    'IncomingCompanyInvites',
    'OutgoingCompanyInvites',
    'OrgSettings',
    'OrgBrandSettings',
    'EmailNoSyncList',
    'ProfileAvailability',
    'ProfileReferees',
    'OrgDateSettings',
    'OrgIntegrations',
    'AvailableIntegrations',
    'JobOffers',
    'Offers',
    'IntegrationFieldMap',
    'IntegrationSettings',
    'CommunicationActivities',
    'CommunicationUserMappings',
    'ResourceRequests',
    'JobIntegrations',
    'JobSummary',
    'CandidateJobs',
    'CandidateApplications',
    'JobActivities',
    'ApplicationActivities',
    'SystemSettings',
    'SystemTerms',
    'Placements',
    'PlacementDocuments',
    'JobPlacements',
    'GlobalOrganizations',
    'GlobalAccounts',
    'ActivationRequest',
    'SystemDocuments',
    'ApplicationProfile',
    'Interviews',
    'ApplicationInterviews',
    'ScreeningQuestionSubmissions',
    'ParentAccounts',
    'ConnectionApplications',
    'BackgroundTasks',
    'ApplicationReferenceRequests',
    'ApplicationReferences',
    'JobBoardAvailability',
    'RejectionTemplateSettings',
    'Companies',
    'CompanyApplications',
    'CompanyJobs',
    'CompanyContacts',
    'Thread',
    'CompanyLink',
    'CompanyContactLink',
    'ContactLink',
    'ContactCompanyLink',
    'ContactDocuments',
    'CompanyDocuments',
    'EntityLabels',
    'CandidateDocuments',
    'Lists',
    'EntityLists',
    'ListItems',
    'EntityListMemberships',
    'Tasks',
    'Deals',
    'DealTasks',
    'PipelineDeals',
    'Pipelines',
    'MyPipelineDeals',
    'ApplySources',
    'NoteTypes',
    'OrganizationReasons',
    // The merged candidate/application notes feed. Keyed by record, not by thread, so a note posted
    // to any one thread has to invalidate it broadly — see threads.service.ts.
    'NotesFeed',

    'DealContactLinks',
    // JT1-1736: the Linked Deals card on a contact / company profile
    'LinkedDeals',
    'DealCompanyLinks',
    'DealDocuments',

    'EmailConnection',
    'MailerSettings',
    'EmailMessageTemplates',
    'EmailActivities',
    'InboundAlias',
    'InboundEmailLogs',

    'FeatureFlags',

    'CustomFieldConfigs',
    'CustomFields',

    'Meetings',
    'MeetingContactLink',

    'Calendar',
    'OrgCalendars',
    'CalendarEvent',
    'CalendarEvents',
    'BookableEventType',
    'BookableEventTypes',
    'AvailabilityRule',
    'AvailabilityRules',

    'Reports',
    'ReportMetadata',

    'OrgPrompt',
    'MeetingPrompt',
    'Nudges',
    'StaleSettings',
    'AiRestrictions',
    // JT1-1815: a job's saved Applicants ranking
    'AiMatch',
    // JT1-1764 to JT1-1771: AI note findings (suggestions, proposed tasks) and suitable jobs
    'AiFindings',
    'SuitableJobs',

    'SigningRequests',
  ],
  baseQuery: axiosBaseQuery({
    baseUrl: import.meta.env.VITE_BACKEND_URL,
  }),
  endpoints: () => ({}),
});
